export const navItems = [
  { label: "How it works", href: "#how-it-works" },
  { label: "Scope & eligibility", href: "#scope" },
  { label: "About founder", href: "#about" },
  { label: "Security & privacy", href: "#security" },
  { label: "Contact", href: "#contact" },
];

export const heroBadges = [
  "HTTPS in transit and encrypted storage",
  "Every return reviewed by a person before e-file",
  "Flat price agreed before any work begins",
];

export const trustMetrics: Array<{ value: string; label: string; accent?: boolean }> = [
  {
    value: "100%",
    label: "Every return reviewed line by line and e-filed by an IRS-registered preparer",
  },
  {
    value: "24h",
    label: "Typical turnaround on simple returns once your intake is complete \u2014 complex returns take longer",
  },
  {
    value: "CA",
    label: "Built exclusively for California full-year individual residents",
  },
  {
    value: "U.S. only",
    label: "Core hosting is in U.S. regions; your data is never sold",
    accent: true,
  },
];

export const featureCards = [
  {
    index: "1",
    title: "Guided, Step-by-Step Intake",
    body: "No dense, confusing tax forms. Answer one question at a time, each one tailored to your life and income situation.",
  },
  {
    index: "2",
    title: "Smart Document Upload",
    body: "Securely upload W-2s, 1099s, and prior returns directly from your phone or computer with automated data extraction.",
  },
  {
    index: "3",
    title: "Real-Time Status Tracking",
    body: "Follow your tax return live through every stage: questionnaire completion, preparer draft review, e-signing, and IRS acceptance.",
  },
  {
    index: "4",
    title: "1-on-1 Preparer Review",
    body: "Every single calculation, deduction, and credit is thoroughly verified by Gaurab Subedi to ensure maximum accuracy and compliance.",
  },
  {
    index: "5",
    title: "Secure Digital Signatures",
    body: "Review your completed Form 1040 and California Form 540 summary and e-sign IRS Form 8879 in seconds with authenticated access and encryption.",
  },
  {
    index: "6",
    title: "Direct Electronic Filing",
    body: "Your return is transmitted electronically to the IRS and the California Franchise Tax Board, and you see each acceptance as it lands.",
  },
];

// Year-one scope rule: we file what the client's own documents support. What we decline is work
// that depends on a record the preparer has to build and carry forward — an inherited depreciation
// schedule, an IRA basis history, an AMT basis. Screening for the parenthesised conditions below
// happens at intake; the page states them so nobody is surprised at the document-upload step.
export const inScopeServices = [
  "W-2 wages and salaries",
  "Interest and dividend income (1099-INT, 1099-DIV)",
  "Stock and fund sales, including wash sales your broker reports (1099-B)",
  "Equity compensation \u2014 RSUs, NQSOs, and ESPP (needs your broker's supplemental statement)",
  "Crypto sold at a US exchange that reports your cost basis (1099-DA)",
  "Retirement, pension, and Social Security income (1099-R, SSA-1099)",
  "Independent contractor and gig work (1099-NEC, 1099-MISC)",
  "Self-employment with equipment fully expensed in the year you bought it (Schedule C)",
  "Partnership and S-corp income you receive on a K-1",
  "Sale of a home you lived in and never rented out",
  "Education, child, and California renter's credits (1098-T)",
  "Standard and itemized deductions, including a capital-loss carryforward from a prior return you provide (Schedule A)",
];

export const outOfScopeServices = [
  "Rental property and royalties (Schedule E), and business equipment already on a depreciation schedule (Form 4562)",
  "Partnership, S-corp, C-corp, and trust returns (Forms 1065, 1120-S, 1120, 1041)",
  "Backdoor Roth conversions, and incentive stock options exercised and held past year end (Forms 8606, 6251)",
  "Foreign income and foreign bank accounts (FBAR, FATCA, Forms 2555 and 1116)",
  "Multi-state, part-year resident, and non-resident state returns",
];

export const securityCards = [
  {
    title: "A Person Reviews Every Return",
    body: "Nothing is filed automatically. Gaurab Subedi reviews every figure, deduction, and credit himself, and you approve the draft before anything is sent.",
  },
  {
    title: "Never Sold; Provider Use Is Controlled",
    body: "Your tax data is used to prepare your return. Provider retention and model-use controls depend on the applicable contract and environment configuration; see our Privacy Policy for the current disclosure.",
  },
  {
    title: "U.S.-Based Core Hosting",
    body: "Our application, database, document storage, and backups are configured in U.S. regions. Third-party processing follows the provider terms and current environment configuration.",
  },
  {
    title: "Encryption & Access Controls",
    body: "HTTPS protects public connections; encrypted storage, authenticated access, role-isolated permissions, and audit-logged critical events protect records.",
  },
];

export const founderDetails = {
  name: "Gaurab Subedi",
  role: "Founder & Tax Preparer",
  subtitle: "CTEC Registered Tax Preparer \u00b7 Founder",
  bio: "Gaurab Subedi founded Subedi Tax Pro to give California individuals and families a filing experience that is straightforward, fast, and personal. He is a CTEC Registered Tax Preparer and an Authorized IRS e-file Provider, and he reviews every return himself before it is filed. Based in Antelope, he serves clients across California remotely.",
  credentials: [
    { label: "CTEC Registered Tax Preparer (CRTP)", value: "California Tax Education Council" },
    { label: "Authorized IRS e-file Provider (ERO)", value: "Returns filed electronically with the IRS" },
    { label: "IRS Preparer Tax Identification Number", value: "Active" },
    { label: "County Business License", value: "Sacramento County GNB32026-02192" },
    { label: "Location", value: "Antelope, Sacramento County, CA" },
  ],
};
